import { CreativeTagEvent, ViewabilityEventConditions } from '../enums';
import { TimerService } from '../services/timer/timer-service';
import { EventEmitter } from '../types';
import { ViewabilityObserver } from '../types/viewability-observer';

// prettier-ignore
// eslint-disable-next-line
const TIME_TRIGGER_THRESHOLDS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 15, 20, 30, 40, 50, 60, 80, 100, 120]; // in s

export class TimespentEventNotifier {
  private readonly thresholds: number[] = [...TIME_TRIGGER_THRESHOLDS];

  constructor(
    observer: ViewabilityObserver,
    private readonly emitter: EventEmitter<CreativeTagEvent>,
    private readonly timer: TimerService = new TimerService()
  ) {
    this.timer.subscribe(this.handleTick.bind(this));

    observer.on(ViewabilityEventConditions.On50PercentVisible, () => {
      // Timer delay is set with the last threshold and convert in ms
      this.timer.delay =
        TIME_TRIGGER_THRESHOLDS[TIME_TRIGGER_THRESHOLDS.length - 1] * 1000;
      this.timer.resume();
    });
    observer.on(ViewabilityEventConditions.OnNotVisible, () => {
      this.timer.pause();
    });
  }

  private handleTick(elapsedMs: number) {
    const elapsedSeconds = Math.floor(elapsedMs / 1000);
    // checked if elapsedSecond if superior to the first threshold of the list
    while (this.thresholds.length && elapsedSeconds >= this.thresholds[0]) {
      // remove the threshold from the list if it has been reached
      const threshold = this.thresholds.shift();
      this.emitTimespentEvent(threshold!);
      // If all thresholds have been reached, clear the notifier
      if (this.thresholds.length === 0) {
        this.clear();
      }
    }
  }

  private emitTimespentEvent(timespent: number) {
    this.emitter.emit(
      CreativeTagEvent.CREATIVE_TIMESPENT,
      new CustomEvent(CreativeTagEvent.CREATIVE_TIMESPENT, {
        detail: { timespent_seconds: timespent }
      })
    );
  }

  private clear() {
    this.timer.pause();
    this.timer.unsubscribe(this.handleTick.bind(this));
  }
}
